module.exports = "/src/views/player/documets/fibbadge/images/ava.png";